import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useRecordContext,
    required,
    NumberInput,
    minValue,
    useDataProvider,
    AutocompleteInput,
} from 'react-admin';

import FileUpload from '../../common/inputs/FileUpload';
import HTMLEditorInput from '../../common/inputs/HTMLEditorInput';
import { EditToolbar } from '../../common/EditToolbar';
import PermissionGuard from '../../common/PermissionGuard';
import useIsPermission from '../../hooks/useIsPermission';
import { validateNotEmpty } from '../../common/VideoPlayer/util';
import { useSearchParams } from 'react-router-dom';

export const TopicsRender = (choice: any) => `${choice.name}`;
const PodcastEdit = () => {
    const [searchParams] = useSearchParams();
    const topicId = searchParams.get('topicId');
    const dataProvider = useDataProvider();

    const isDisabled = !!topicId;
    const [topics, setTopics] = React.useState([]) as any;

    React.useEffect(() => {
        dataProvider
            .getList('podcast-topics', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => setTopics(data))
            .catch(error => console.error(error));
    }, [dataProvider]);

    const { isUpdatable } = useIsPermission('PODCAST');
    return (
        <PermissionGuard permission={isUpdatable}>
            <Edit mutationMode={'pessimistic'} title={<Title />} redirect={'/podcasts'}>
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload
                        type="VIDEO_THUMBNAIL"
                        source={'thumbnail'}
                        required={true}
                        accept={'image/*'}
                    />
                    <TextInput source="title" fullWidth validate={[required(), validateNotEmpty]} />
                    <FileUpload
                        source="url"
                        type="PODCAST"
                        label="select audio file"
                        required={true}
                        accept={'audio/*'}
                    />
                    <NumberInput source="displayOrder" fullWidth validate={[minValue(1)]} />
                    <AutocompleteInput
                        source="topicId"
                        choices={topics}
                        optionText={TopicsRender}
                        fullWidth
                        isRequired
                        disabled={isDisabled}
                    />
                    <HTMLEditorInput source={'description'} fullWith />
                </SimpleForm>
            </Edit>
        </PermissionGuard>
    );
};

const Title = () => {
    const record = useRecordContext();
    return record ? <span>{record.title}</span> : null;
};

export default PodcastEdit;
